import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import { ContextApp } from '../../context';
import getTranslateProps from '../../utils/getTranslateProps';
import SearchIcon from '../../images/search.png';

const FilterContent = ({ uniqMoviesParameters, filtersForm, lastType, queryStringContext, onHandleChangeUpdateFiltersForm, onHandleChangeSearchFilter, onSelectivelyClearFilterForm }) => {
    return (
        <form className='filmik__filters'>
            <div className='filmik__search'>
                <p className='filmik__filter-list-title'>Поиск по {(lastType) ? getTranslateProps('type', lastType) + 'ам' : 'всему'}</p>
                <label className='filmik__search-label'>
                    <input className='filmik__search-input' type='search' placeholder='Введите название' onChange={onHandleChangeSearchFilter} />
                    <img className='filmik__search-img' src={SearchIcon} alt='search icon'/>
                </label>
            </div>
            <ul className='filmik__filter-list'>
                {
                    uniqMoviesParameters.map((parameter) => {
                        return (
                            <li className='filmik__filter-list-item' key={parameter.type}>
                                <div className='filmik__filter-list-item-box'>
                                    <p className='filmik__filter-list-title'>{parameter.title}</p>
                                    {
                                        (queryStringContext[parameter.type].length) ? <button className='filmik__filter-list-btn' data-clearfilter={parameter.type} type='button' onClick={onSelectivelyClearFilterForm}></button> : null
                                    }
                                </div>
                                <ul className={parameter.type !== 'year' ? 'filmik__filter-detailed' : 'filmik__year-detailed'}>
                                    {
                                        parameter.list.map((item) => {
                                            const [rus, eng] = item.split('=');

                                            return (
                                                <li className={parameter.type !== 'year' ? 'filmik__filter-detailed-item' : 'filmik__year-detailed-item'} key={eng}>
                                                    <label className='filmik__filter-detailed-label'><input
                                                        className='filmik__filter-detailed-input' type='checkbox'
                                                        name={eng} data-myfilter={parameter.type} onChange={onHandleChangeUpdateFiltersForm} checked={filtersForm[parameter.type][eng]} />{rus}</label>
                                                </li>
                                            );
                                        })
                                    }
                                </ul>
                            </li>
                        );
                    })
                }
            </ul>
        </form>
    );
};

FilterContent.propTypes = {
    uniqMoviesParameters: PropTypes.array.isRequired,
    filtersForm: PropTypes.object.isRequired,
    lastType: PropTypes.string.isRequired,
    queryStringContext: PropTypes.object.isRequired,
    onHandleChangeUpdateFiltersForm: PropTypes.func.isRequired,
    onHandleChangeSearchFilter: PropTypes.func.isRequired,
};

const FilterContentContainer = () => {
    const { state: { movies, lastType, queryString: queryStringContext }, actions: { updateQueryString, updateSearchFilter, selectivelyClearQueryString } } = useContext(ContextApp);
    const location = useLocation();
    const query = queryString.parse(location.search, {arrayFormat: 'comma'});

    const uniqMoviesParameters = getUniqMoviesParameters();
    const [filtersForm, setFiltersForm] = useState(dataForFiltersForm);

    function getUniqMoviesParameters() {
        const uniqMoviesParameters = [
            {
                title: 'Жанр',
                type: 'genre',
                list: [],
            },
            {
                title: 'Страна',
                type: 'country',
                list: [],
            },
            {
                title: 'Год',
                type: 'year',
                list: [],
            },
        ];
        const preparedMoviesParameters = [];

        movies.forEach((movie) => {
            const preparedMovieParameters = movie.parameters.map((filter) => {
                const [name, values] = filter.split('=');

                return {
                    type: name,
                    list: [...values.split(',')],
                };
            });

            preparedMoviesParameters.push(preparedMovieParameters);
        });

        preparedMoviesParameters.forEach((preparedMovieParameters) => {
            for (let i = 0; i < preparedMovieParameters.length; i++) {
                preparedMovieParameters[i].list.forEach((value) => {
                    if (!uniqMoviesParameters[i].list.includes(value)) {
                        uniqMoviesParameters[i].list.push(value);
                    }
                })
            }
        });

        uniqMoviesParameters.forEach((uniqMovieParameters) => {
            uniqMovieParameters.list = uniqMovieParameters.list.map((parameter) => {
                return `${getTranslateProps(uniqMovieParameters.type, parameter)}=${parameter}`;
            });
            uniqMovieParameters.list.sort();
        });

        return uniqMoviesParameters;
    }
    function dataForFiltersForm() {
        function queryChecked(parameters, currentDataFromFiltersForm) {
            if (Array.isArray(parameters)) {
                parameters.forEach((parameter) => currentDataFromFiltersForm[parameter] = true);
            } else {
                currentDataFromFiltersForm[parameters] = true;
            }
        }

        const mappedUniqMoviesParameters = uniqMoviesParameters.map((uniqMovieParameters) => {
            const listParametersEng = uniqMovieParameters.list.map((parameter) => {
                return parameter.split('=')[1];
            });

            const objParameters = {};

            listParametersEng.forEach((parameterEng) => {
                objParameters[parameterEng] = false;
            });

            return objParameters;
        });

        const [genre, country, year] = mappedUniqMoviesParameters;

        for (let prop in query) {
            switch (prop) {
                case 'genre':
                    queryChecked(query[prop], genre);

                    break;

                case 'country':
                    queryChecked(query[prop], country);

                    break;

                case 'year':
                    queryChecked(query[prop], year);

                    break;

                default:
            }
        }

        return {
            genre,
            country,
            year,
        };
    }
    function onHandleChangeUpdateFiltersForm(event) {
        window.scrollTo(0, 0);
        setFiltersForm((formFilter) => {
            return {
                ...formFilter,
                [event.target.dataset.myfilter]: {
                    ...formFilter[event.target.dataset.myfilter],
                    [event.target.name]: !formFilter[event.target.dataset.myfilter][event.target.name],
                },
            };
        });

        updateQueryString(event);
    }
    function onHandleChangeSearchFilter(event) {
        updateSearchFilter(event.target.value);
    }

    function onSelectivelyClearFilterForm(event) {
        setFiltersForm((formFilter) => {
            const newObj = {};

            for (let prop in formFilter) {
                if (prop === event.target.dataset.clearfilter) {
                    for (let propName in formFilter[event.target.dataset.clearfilter]) {
                        newObj[propName] = false;
                    }
                }
            }

            return {
                ...formFilter,
                [event.target.dataset.clearfilter]: {
                    ...newObj,
                },
            };
        });

        selectivelyClearQueryString(event);
    }

    return (
        <FilterContent
            uniqMoviesParameters={uniqMoviesParameters}
            filtersForm={filtersForm}
            lastType={lastType}
            queryStringContext={queryStringContext}
            onHandleChangeUpdateFiltersForm={onHandleChangeUpdateFiltersForm}
            onHandleChangeSearchFilter={onHandleChangeSearchFilter}
            onSelectivelyClearFilterForm={onSelectivelyClearFilterForm}
        />
    );
};

export default FilterContentContainer;